// search-results-store-auto-select.js
// Auto-select "All Brands" for search results pages

// Check if isAllBrands function exists, if not create a local version
if (typeof isAllBrands === 'undefined') {
  window.isAllBrands = (storeValue) => {
    if (!storeValue) return false;
    const normalized = storeValue.toLowerCase().trim();
    return normalized === 'all brands' || normalized === 'all brand' || normalized.includes('all');
  };
}

// Auto-select "All Brands" for search results pages
const autoSelectAllBrandsForSearchResults = () => {
  // Check if current URL starts with the search results page
  if (window.location.href.startsWith('https://quoruminternational.com/pages/search-results-page')) {
    // Set the store to "all brands" in localStorage
    localStorage.setItem("store-selected", "all brands");
    
    // Update the HTML dataset
    const htmlEL = document.querySelector("html");
    if (htmlEL) {
      htmlEL.dataset.storeSelected = "all brands";
    }
    
    // Function to update radio buttons
    const updateRadioButtons = () => {
      const allInputs = document.querySelectorAll('store-switcher input[type="radio"]');
      
      allInputs.forEach((input) => {
        if (isAllBrands(input.value)) {
          input.checked = true;
          input.setAttribute('checked', '');
        } else {
          input.checked = false;
          input.removeAttribute('checked');
        }
      });
    };
    
    // If DOM is already loaded, update immediately
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        updateRadioButtons();
        if (typeof setCollectionsFilters === 'function') {
          setCollectionsFilters();
        }
        if (typeof theme !== 'undefined' && theme.headerNav) {
          theme.headerNav.init();
        }
      });
    } else {
      // DOM is already ready
      updateRadioButtons();
      if (typeof setCollectionsFilters === 'function') {
        setCollectionsFilters();
      }
      if (typeof theme !== 'undefined' && theme.headerNav) {
        theme.headerNav.init();
      }
    }
  }
};

// Run the auto-selection as early as possible
autoSelectAllBrandsForSearchResults();

// Initialize everything when DOM loads
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    autoSelectAllBrandsForSearchResults();
  });
} else {
  autoSelectAllBrandsForSearchResults();
}